module.exports = __webpack_public_path__ + "static/media/fmmobiles.728b95a8.png";